export default function AboutSection() {
  return (
    <section className="relative w-full bg-background-100 py-24 md:py-32 lg:py-40 px-8 md:px-16 lg:px-24 xl:px-32">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="sticky top-32">
              <span className="inline-block text-xs tracking-[0.2em] uppercase text-foreground-400 font-medium mb-6">
                About
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-medium text-foreground-950 leading-[1.15]">
                Engineering with purpose, built to last
              </h2>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-6">
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality. Every project is approached with the discipline of professional software engineering — from architecture design through to delivery and ongoing evolution.
              </p>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                The team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design. These principles guide every decision, ensuring that the systems we deliver remain robust, adaptable, and aligned with the highest technical standards.
              </p>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                Continuous innovation drives everything we do. We actively explore new technologies and evolve our internal processes to maintain high technical excellence, constantly improving development workflows and adopting up-to-date engineering standards.
              </p>
            </div>

            <div className="mt-16 grid grid-cols-3 gap-8 pt-12 border-t border-background-300/60">
              <div>
                <div className="text-3xl font-heading font-semibold text-accent-500 mb-2">Clean</div>
                <p className="text-sm text-foreground-500 leading-relaxed">Architecture that prioritizes maintainability and separation of concerns</p>
              </div>
              <div>
                <div className="text-3xl font-heading font-semibold text-accent-500 mb-2">Scalable</div>
                <p className="text-sm text-foreground-500 leading-relaxed">Systems designed to grow seamlessly with evolving requirements</p>
              </div>
              <div>
                <div className="text-3xl font-heading font-semibold text-accent-500 mb-2">Reliable</div>
                <p className="text-sm text-foreground-500 leading-relaxed">Built for stability under real-world conditions with rigorous quality practices</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}